// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"post-preview_wrapper__LLM0n","image":"post-preview_image__uxezT","link":"post-preview_link__pP3sc","content":"post-preview_content__MBue4"};